/*
 * $Id:: service.js 2021/03/02 11:11 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { sendRequest } from '../../common/utils';
import { getLocale } from '../../providers';

export const fetchApplicationsPaginated = ({ userId, params }) => {
    const { requestBody, selectedTab } = params;
    const lang = getLocale();
    const url = `/applications/${selectedTab}/${lang}`;
    return sendRequest({
        url,
        method: 'POST',
        body: {
            ...requestBody,
            userId: userId,
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code } };
        });
};

export const fetchApplicationReceipt = (params) => {
    const { appId, ipRightType, applicationType } = params;
    const appRightType = (ipRightType || applicationType).toLowerCase();
    const lang = getLocale();
    return sendRequest({
        url: `/applications/${applicationType}/${appRightType}/${appId}/receipt/${lang}`,
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { code: error.code || 500, description: 'Could not fetch application pdf' } };
        });
};

export const fetchApplicationsExport = ({ params }) => {
    const { requestBody, applicationType, type } = params;
    const lang = getLocale();
    return sendRequest({
        url: `/applications/${applicationType}/${type}/${lang}`,
        method: 'POST',
        body: {
            ...requestBody,
        },
        returnJSON: false,
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return {
                error: {
                    code: error.code || 500,
                    description: `Could not fetch ${requestBody.isDraft && 'draft'} applications ${type}`,
                },
            };
        });
};

export const fetchImage = ({ userId, params }) => {
    const { requestBody, selectedTab } = params;
    const lang = getLocale();
    const url = `/images/${selectedTab}/${lang}`;
    return sendRequest({
        url,
        method: 'POST',
        body: {
            ...requestBody,
            userId: userId,
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code } };
        });
};
